import { Observable } from "rxjs";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { Injectable } from "@angular/core";
import { ModalData } from "./modal.interface";
import { ComponentType } from "@angular/cdk/portal";

@Injectable()
export class ModalService {
  private dialogRef: MatDialogRef<ComponentType<any>>;
  constructor(private dialog: MatDialog) {}

  public openModal(options: ModalData): MatDialogRef<any> {
    this.dialogRef = this.dialog.open(options.component, {
      maxHeight: "50em",
      minHeight: "10em",
      width: "50em",
      disableClose: true,
      data: options.data,
    });

    return this.dialogRef;
  }

  public close(): Observable<boolean> {
    return this.dialogRef.afterClosed();
  }
}
